import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "profile" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Autosave = _resolveComponent("Autosave")
  const _component_BuilderInputs = _resolveComponent("BuilderInputs")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")
  const _component_ResetModal = _resolveComponent("ResetModal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SettingsFrame, { title: "Profile" }, {
      description: _withCtx(() => [
        _cache[3] || (_cache[3] = _createTextVNode(" Update your photo and personal details here. ")),
        (_ctx.$global.onboarding_enabled)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[1] || (_cache[1] = _createTextVNode(" (you can reset and restart the onboarding chat ")),
              _createElementVNode("span", {
                class: "pointer",
                style: {"text-decoration":"underline"},
                onClick: _cache[0] || (_cache[0] = $event => ($options.onReset()))
              }, "here"),
              _cache[2] || (_cache[2] = _createTextVNode(") "))
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]),
      right: _withCtx(() => [
        _createVNode(_component_Autosave, {
          valid: $data.valid,
          saving: $options.saving,
          saved_at: $options.saved_at
        }, null, 8 /* PROPS */, ["valid", "saving", "saved_at"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_BuilderInputs, {
            "vread-from": "valid",
            "onUpdate:valid": $event => (($data.valid) = $event),
            col: "",
            gap: "2rem",
            opts: $data.schema,
            onUpdate: $options.onUpdate
          }, null, 8 /* PROPS */, ["onUpdate:valid", "opts", "onUpdate"])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_ResetModal, { ref: "reset" }, null, 512 /* NEED_PATCH */)
  ], 64 /* STABLE_FRAGMENT */))
}